export default "__VITE_ASSET__QVTw6rMX__"